import { Seo as ServerSeo } from '@shopify/hydrogen'
import { Seo as SeoType } from '@shopify/hydrogen/storefront-api-types'
import { useI18n } from './i18n.client'

interface ExtendedSeoType extends SeoType {
  title: string
  type: 'noindex' | 'page'
}

export const Seo: React.FC<ExtendedSeoType> = ({ title, ...props }) => {
  const [i18n] = useI18n()

  return <ServerSeo {...props} data={{ title: i18n.translate(title) }} />
}
